import { ref } from "vue";
import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
  type Router,
  type RouteRecordRaw,
  type RouteRecordNormalized,
  type RouteLocationNormalized,
  type NavigationGuardNext,
  type RouteLocationRaw,
  RouteLocationNormalizedLoaded,
  NavigationFailure
} from "vue-router";
export {
  RouterLink,
  RouterView,
  useRouter,
  useRoute,
  type Router
} from "vue-router";
import ViewDocument from "../components/form/ViewDocument.vue";
import Lot from "../components/xg/Lot.vue";
import Park from "../components/xg/Park.vue";
import Index from "../pages/Index.vue";
import ShapeShowCase from "../pages/ShapeShowCase.vue";
import ComponentShowCase from "../pages/ComponentShowCase.vue";
import RxMarbles from "../pages/RxMarbles.vue";

const router = createRouter({
  // history: createWebHistory(import.meta.env.BASE_URL),
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: [
    // {
    //   path: "/",
    //   name: "xg",
    //   redirect: "/lot" // for <yz-xg /> WebComponent
    // },
    {
      path: "/",
      name: "index",
      component: Index
    },
    {
      path: "/shape",
      name: "shape",
      component: ShapeShowCase
    },
    {
      path: "/cs",
      name: "cs",
      component: ComponentShowCase
    },
    {
      path: "/lot",
      name: "lot",
      component: Lot
    },
    {
      path: "/park",
      name: "park",
      component: Park
    },
    {
      path: "/rx/:operator?",
      name: "rx",
      component: RxMarbles
    },
    {
      path: "/view-document/:title/:src",
      name: "view-document",
      component: ViewDocument
      // props: true // error :  https://github.com/vuejs/router/blob/main/packages/router/CHANGELOG.md#414-2022-08-22
    }
  ],
  // [
  //   {
  //     path: "/",
  //     redirect: "/showcase"
  //   },
  //   {
  //     path: "/",
  //     path: "/demo/:demoid",
  //     name: "home",
  //     component: HomeView,
  //     // router level code-splitting
  //     // this generates a separate chunk (About.[hash].js) for this router
  //     // which is lazy-loaded when the router is visited.
  //     component: () => import("../views/AboutView.vue"),
  //     meta: {},
  //     children: [
  //       { path: "", name: "default", redirect: "/demo/sub1" },
  //       {
  //         path: "sub1",
  //         name: "sub1",
  //         component: () => import("@/src/views/sub1.vue")
  //       }
  //     ]
  //   },
  //   {
  //     path: "/:pathMatch(.*)*",
  //     name: "404",
  //     component: Page404
  //   }
  // ]
  scrollBehavior: (_to, _from, savedPosition) => {
    // 这个功能只在支持 history.pushState 的浏览器中可用
    if (savedPosition) {
      return savedPosition;
    } else {
      return { left: 0, top: 0 };
    }
  }
});

export default router;

// <RouterLink to="/">Home</RouterLink>
// <RouterLink to="/about">About</RouterLink>
// <RouterView />

// import { useRouter, useRoute } from "../hooks";
// const router: Router  = useRouter();
// router.push("/wc");
// const route = useRoute();
// route.query
// route.params

// next: 前进 prev: 返回
export const routeDirection = ref<"next" | "prev">("next");
const routeList = [];

// 路由导航守卫
router.beforeEach(
  (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext
  ) => {
    // console.log(to, from);
    // console.log(...routeList, " : ", to.name);
    const length = routeList.length;
    const index = routeList.findIndex((r) => r == to.name);
    if (length > 1 && index >= 0 && index < length - 1) {
      routeDirection.value = "prev";
      routeList.splice(index + 1);
    } else {
      routeDirection.value = "next";
      routeList.push(to.name);
    }
    // console.log(routeDirection.value);
    next();
  }
);

// router.afterEach(
//   (
//     to: RouteLocationNormalized,
//     from: RouteLocationNormalizedLoaded,
//     failure?: NavigationFailure | void
//   ) => {}
// );

// export async function push(location: RouteLocationRaw) {
//   const router: Router = useRouter();
//   await router.push(location);
// }

// {
//   name: Name;
//   path: Path;
//   paramsRaw: ParamsRaw;
//   params: Params;
//   meta: Meta;
// }
// export async function to(this: any, path: string) {
//   await push({ path });
// }

// 动态注册路由
// const remove = addRoute("demo", {
//   path: "sub2",
//   name: "sub2",
//   component: () => import("@/src/views/sub2.vue")
// });
// remove();
// export function addRoute(route: RouteRecordRaw): () => void {
//   const router: Router = useRouter();
//   return router.addRoute(route);
// }

// export function removeRoute(name: string) {
//   const router: Router = useRouter();
//   router.removeRoute(name);
// }

// export function hasRoute(name: string): boolean {
//   const router: Router = useRouter();
//   return router.hasRoute(name);
// }

// export function getRoutes(): RouteRecordNormalized[] {
//   const router: Router = useRouter();
//   return router.getRoutes();
// }

// export function getCurrentRouteDetail() {
//   const router: Router = useRouter();
//   return {
//     params: router.currentRoute.value.params,
//     query: router.currentRoute.value.query
//   };
// }
